import { parse, stringify } from "flatted";

export function deepCopyFrom<T>(source: T) {
	try {
		return structuredClone(source);
	} catch {
		return parse(stringify(source));
	}
}
